<div id="alumni-meet" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h1 class="title">Alumni Meet</h1>

    <!-- Tab Navigation -->
    <div class="report-tabs-wrapper mt-4">
      <div class="report-tabs">
        <button class="tab-btn" [class.active]="activeTab === 'description'" (click)="setActiveTab('description')">
          <i class="fa fa-info-circle me-2"></i> Description
        </button>
        <button class="tab-btn" [class.active]="activeTab === 'gallery'" (click)="setActiveTab('gallery')">
          <i class="fa fa-image me-2"></i> Gallery
        </button>
        <button class="tab-btn" [class.active]="activeTab === 'sessions'" (click)="setActiveTab('sessions')">
          <i class="fa fa-video me-2"></i> Alumni Meet Sessions
        </button>
        <button class="tab-btn" [class.active]="activeTab === 'registered'" (click)="setActiveTab('registered')">
          <i class="fa fa-user-plus me-2"></i> Registered
        </button>
      </div>
    </div>

    <!-- Content Area -->
    <div class="tab-content-area mt-5">

      <!-- Description Tab -->
      <div *ngIf="activeTab === 'description'" class="animate-fade-in">
        <div class="inner-lead">
          <h4 class="section-subtitle-orange mb-3">Distinguished Alumnae</h4>
          <h5 class="mb-4 text-muted"><em>“From Alma Mater to Ascending to Zenith”</em></h5>
          <p>As <em>"Strong roots create powerful wings."</em> At Shah Satnam Ji Girls' College, Sirsa, we take immense pride in the remarkable accomplishments of our alumnae, who have excelled in various professional fields and brought honour to our institution.</p>
          
          <div class="row mt-4">
            <div class="col-md-12">
              <ul class="download-list">
                <li class="download-item">
                  <div class="download-item-label">
                    <strong>Principals:</strong> Leading educational institutions with vision and dedication, shaping the future of countless students.
                  </div>
                </li>
                <li class="download-item">
                  <div class="download-item-label">
                    <strong>International Coaches:</strong> Training and mentoring athletes on a global scale, driving excellence in sports.
                  </div>
                </li>
                <li class="download-item">
                  <div class="download-item-label">
                    <strong>Professors and Lecturers:</strong> Imparting knowledge and inspiring young minds in renowned universities and colleges.
                  </div>
                </li>
                <li class="download-item">
                  <div class="download-item-label">
                    <strong>Lieutenants:</strong> Serving with distinction and honour in the defence forces, safeguarding our nation.
                  </div>
                </li>
                <li class="download-item">
                  <div class="download-item-label">
                    <strong>Bank Managers:</strong> Overseeing financial operations and ensuring robust banking services.
                  </div>
                </li>
                <li class="download-item">
                  <div class="download-item-label">
                    <strong>Officers in Multinational Companies:</strong> Demonstrating leadership and innovation in globally recognized corporations.
                  </div>
                </li>
                <li class="download-item">
                  <div class="download-item-label">
                    <strong>Judicial Officials:</strong> A long array of alumnae who have made their mark in the field of Judiciary, serving with dedication.
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Gallery Tab -->
      <div *ngIf="activeTab === 'gallery'" class="animate-fade-in">
        
        <!-- Folder Selection View -->
        <div *ngIf="!selectedFolder" class="row g-4 mt-2">
          <div class="col-md-6">
            <div class="folder-card" (click)="selectFolder('moments')">
              <div class="folder-icon">
                <i class="fa fa-folder-open"></i>
              </div>
              <div class="folder-info">
                <h4>Moments</h4>
                <p>{{moments.length}} Photos</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="folder-card" (click)="selectFolder('memories')">
              <div class="folder-icon">
                <i class="fa fa-folder-open"></i>
              </div>
              <div class="folder-info">
                <h4>Sweet Memories</h4>
                <p>{{memories.length}} Photos</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Selected Folder View -->
        <div *ngIf="selectedFolder">
          <button (click)="selectFolder(null)" class="btn btn-link text-primary p-0 mb-4 text-decoration-none fw-bold">
            <i class="fa fa-arrow-left me-2"></i> Back to Folders
          </button>

          <div *ngIf="selectedFolder === 'moments'">
            <h4 class="section-subtitle mb-4">Moments Gallery</h4>
            <div class="gallery-grid">
              <div *ngFor="let img of moments">
                <a href="assets/img/alumni/moments/{{img}}" data-lightbox="moments" [attr.data-title]="'Alumni Meet Moment'">
                  <img src="assets/img/alumni/moments/{{img}}" class="gallery-img shadow-sm" 
                       onerror="this.src='assets/img/logo/logo1.png'">
                </a>
              </div>
            </div>
          </div>

          <div *ngIf="selectedFolder === 'memories'">
            <h4 class="section-subtitle mb-4">Sweet Memories Gallery</h4>
            <div class="gallery-grid">
              <div *ngFor="let img of memories">
                <a href="assets/img/alumni/sweet-memories/{{img}}" data-lightbox="sweet-memories" [attr.data-title]="'Alumni Meet Memory'">
                  <img src="assets/img/alumni/sweet-memories/{{img}}" class="gallery-img shadow-sm" 
                       onerror="this.src='assets/img/logo/logo1.png'">
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Sessions Tab -->
      <div *ngIf="activeTab === 'sessions'" class="animate-fade-in">
        <h4 class="section-subtitle-orange mb-4">Event Sessions & Recordings</h4>
        <p class="mb-5">We are delighted to share the recorded sessions of our past Alumni Meets. Click on the links below to watch the event highlights and recordings on Facebook.</p>
        
        <div class="row g-4 mt-2">
          <!-- Session 2025-26 -->
          <div class="col-md-6">
            <div class="session-card">
              <div class="session-icon">
                <i class="fab fa-facebook"></i>
              </div>
              <div class="session-info">
                <span class="badge bg-success mb-2 text-white">Latest Session</span>
                <h4>Session 2025-26</h4>
                <p>Watch the complete recording of the Alumni Meet event for the 2025-26 session on Facebook.</p>
                <a href="https://www.facebook.com/share/p/1ED8awRZtQ/?mibextid=wwXIfr" target="_blank" class="session-link-btn">
                  <i class="fab fa-facebook-f me-2"></i> Watch Event Session <i class="fa fa-external-link-alt ms-2"></i>
                </a>
              </div>
            </div>
          </div>

          <!-- Session 2024-25 -->
          <div class="col-md-6">
            <div class="session-card">
              <div class="session-icon">
                <i class="fab fa-facebook"></i>
              </div>
              <div class="session-info">
                <h4>Session 2024-25</h4>
                <p>The 2024-25 Alumni Meet event was streamed in two separate parts. Click below to view each part.</p>
                <div class="part-buttons mt-3">
                  <a href="https://www.facebook.com/share/1aRZ8sczGD/?mibextid=wwXIfr" target="_blank" class="session-link-btn me-2 mb-2">
                    <i class="fab fa-facebook-f me-2"></i> Part 1 <i class="fa fa-external-link-alt ms-2"></i>
                  </a>
                  <a href="https://www.facebook.com/share/1A1idGs344/?mibextid=wwXIfr" target="_blank" class="session-link-btn mb-2">
                    <i class="fab fa-facebook-f me-2"></i> Part 2 <i class="fa fa-external-link-alt ms-2"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- Session 2023-24 -->
          <div class="col-md-6">
            <div class="session-card">
              <div class="session-icon">
                <i class="fab fa-facebook"></i>
              </div>
              <div class="session-info">
                <h4>Session 2023-24</h4>
                <p>Relive the beautiful memories of the Alumni Meet event for the 2023-24 session on Facebook.</p>
                <a href="https://www.facebook.com/share/v/1HFSGk6aQf/?mibextid=wwXIfr" target="_blank" class="session-link-btn">
                  <i class="fab fa-facebook-f me-2"></i> Watch Event Session <i class="fa fa-external-link-alt ms-2"></i>
                </a>
              </div>
            </div>
          </div>

          <!-- Session 2022-23 -->
          <div class="col-md-6">
            <div class="session-card">
              <div class="session-icon">
                <i class="fab fa-facebook"></i>
              </div>
              <div class="session-info">
                <h4>Session 2022-23</h4>
                <p>Watch the recording of the 2022-23 Alumni Meet session and connect with past classmates.</p>
                <a href="https://www.facebook.com/share/1AKwiTzytz/?mibextid=wwXIfr" target="_blank" class="session-link-btn">
                  <i class="fab fa-facebook-f me-2"></i> Watch Event Session <i class="fa fa-external-link-alt ms-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Registered Tab -->
      <div *ngIf="activeTab === 'registered'" class="animate-fade-in">
        <div class="highlight-box text-center py-5">
          <h4 class="mb-4">Alumni Registration</h4>
          <p class="mb-4">Join our esteemed alumni network and stay connected with your alma mater. Fill out the registration form to receive updates on upcoming meets and events.</p>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLScyWRDgb2phu8KVvA0o8WOe3YHFDMzs2A6LfsVQDM7AcxE4Ww/viewform?usp=header"
            target="_blank" class="pdf-download-btn mx-auto">
            <i class="fa fa-external-link me-2"></i> Click to Fill out Google Form
          </a>
        </div>
      </div>

    </div>
  </div>
</div>